'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense, useEffect, useMemo } from 'react';
import { useCookie } from 'react-use';

import { segment } from '@/lib/tracking/segmentAnalytics';

export function TrackPageView() {
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const [isCustomerCookie] = useCookie('prezly_customer');
    const isCustomer = isCustomerCookie === '1';

    // Ensure we only create the URL on the client side
    const currentUrl = useMemo(() => {
        if (typeof window === 'undefined' || !pathname) return null;
        let url = window.origin + pathname;
        if (searchParams.toString()) {
            url += `?${searchParams.toString()}`;
        }
        return url;
    }, [pathname, searchParams]);

    useEffect(() => {
        if (!currentUrl) return;

        if (segment) {
            (async () => {
                await segment.page(undefined, undefined, { isCustomer });
            })();
        }
    }, [currentUrl, isCustomer]);

    return null;
}

// Wrap this in Suspense to avoid the `useSearchParams` usage above
// from de-opting the whole app into client-side rendering
// See: https://nextjs.org/docs/messages/deopted-into-client-rendering
export default function SuspendedPageView() {
    // const hasCookie = useHasCookie();
    // const getCookie = useGetCookie();
    // const customerCookie = getCookie('prezly_customer');
    //
    // console.log('Cookies', customerCookie);

    // useEffect(() => {
    //     const customerCookie = hasCookie('prezly_customer')
    //         ? Number(getCookie('prezly_customer'))
    //         : 0;
    //     setIsCustomer(customerCookie === 1);
    // }, [hasCookie, getCookie]);

    return (
        <Suspense fallback={null}>
            <TrackPageView />
        </Suspense>
    );
}
